import { isOK } from "../../helpers/Utils";
import {
  MakeAuthHeader,
  PhocusEnigmaApi,
  PrimePoiApiRoot
} from "../../config/api";
import axios from "axios";
import { Group } from "../../models/Group";

const state = {
  loading: false,
  groupsLoading: false,
  groups: [],
  correlation: null,
  activeGroup: null,
  allGroups: [],
  repairGroups: []
};

const getters = {
  loading(state) {
    return state.loading;
  },
  groupsLoading(state) {
    return state.groupsLoading;
  },
  correlation(state) {
    return state.correlation;
  },
  groups(state) {
    return state.groups;
  },
  activeGroup(state) {
    return state.activeGroup;
  },
  activeGroupObj(state) {
    if(state.activeGroup) {
      return state.groups.find(l => l.groupId == state.activeGroup);
    }
    else {
      return null;
    }
  },
  allGroups(state) {
    return state.allGroups;
  },
  repairGroups(state) {
    return state.repairGroups;
  }
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setGroupsLoading(state, payload) {
    state.groupsLoading = payload;
  },
  setGroups(state, payload) {
    state.groups = payload;
  },
  setActiveGroup(state, payload) {
    state.activeGroup = payload;
  },
  setAllGroups(state, payload) {
    state.allGroups = payload;
  },
  setAllGroupPois(state, payload) {
    state.allGroups.forEach(group => {
      var pois = payload.filter(l => l.customerGroupId == group.id);
      group.pois = pois;
    });
  },
  removeGroupPoi(state, payload) {
    var group = state.allGroups.find(l => l.id == payload.group);
    group.pois = group.pois.filter(l => l.id != payload.poi);
    state.allGroups = state.allGroups.filter(l => l.id != -1);
  },
  setRepairGroups(state, payload) {
    state.repairGroups = payload;
  },
  setRepairGroupPois(state, payload) {
    state.repairGroups.forEach(group => {
      var pois = payload.filter(l => l.customerGroupId == group.id);
      group.pois = pois;
    });
  },
  removeRepairPoi(state, payload) {
    var group = state.repairGroups.find(l => l.id == payload.group);
    group.pois = group.pois.filter(l => l.id != payload.poiId);
    state.repairGroups = state.repairGroups.filter(l => l.id != -1);
  }
};

const actions = {
  async GetGroupsForTechnician({ commit, rootGetters, dispatch }) {
    commit("setLoading", true);
    const technicianId = rootGetters["login/technicianId"];
    const token = rootGetters["login/poiApiToken"];
    const url = `${PrimePoiApiRoot}poiCollection/groupsByTechnicianId`;

    const options = {
      url: url,
      data: { technician: technicianId },
      headers: MakeAuthHeader(token),
      method: "POST"
    };
    const resp = await axios(options);
    if (isOK(resp)) {
      await dispatch("GetPois", resp.data);
    } else {
      commit("setLoading", false);
    }
  },
  async GetPois({ commit, rootGetters }, groups) {
    commit("setLoading", true);

    const token = rootGetters["login/phocusEnigmaApiToken"];
    const url = `${PhocusEnigmaApi}group/groupsForPoi`;
    const groupIds = groups.map(x => x.groupId);
    const options = {
      url: url,
      headers: MakeAuthHeader(token),
      method: "POST",
      data: groupIds
    };
    const resp = await axios(options);
    if (isOK(resp)) {
      let poiGroups = [];
      if (resp.data.length == groups.length) {
        //merge pois with groups into single collection
        for (let i = 0; i < resp.data.length; i++) {
          const item = poiGroups.find(x => x.groupId == groups[i].groupId);

          if (item) {
            item.poiIds.push(groups[i].locationId);
          } else {
            const g = resp.data[i];
            const group = {
              id: g.id,
              isEnigma: g.isEnigma,
              name: g.name,
              poiIds: [groups[i].locationId],
              account: g.account
            };
            poiGroups.push(new Group(group));
          }
        }
      }

      commit("setGroups", poiGroups);
    } else {
      console.log(resp.data);
    }
    commit("setLoading", false);
  },
  GetAllGroups({ commit, dispatch, rootGetters }) {
    return new Promise(resolve => {
      commit("setAllGroups", []);
      commit("setGroupsLoading", true);
      const token = rootGetters["login/phocusEnigmaApiToken"];
      const data = {
        accountId: rootGetters["login/selectedAccount"].id,
        technicianId: rootGetters["login/technicianId"],
        allGroups: true
      };

      let options = {
        headers: MakeAuthHeader(token),
        url: `${PhocusEnigmaApi}DeploymentGroup/assignedIds`,
        method: "POST",
        data: data
      };
      axios(options)
        .then(resp => {
          commit("setAllGroups", resp.data);
          dispatch("GetGroupPois")
          .then(res => {
            commit("setGroupsLoading", false);
            resolve(res);
          })
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
          commit("setGroupsLoading", false);
        });
    });
  },
  GetGroupPois({ getters, commit, rootGetters }) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}poiCollection/GetUnnassignedPois`;
      const data = {
        accountId: rootGetters["login/selectedAccount"].id,
        technicianId: rootGetters["login/technicianId"],
        groups: getters.allGroups.map(l => l.id)
      };

      let options = {
        headers: MakeAuthHeader(token),
        url: url,
        method: "POST",
        data: data
      };
      axios(options)
        .then(resp => {
          commit("setAllGroupPois", resp.data);
          resolve(true);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
    
  },
  GetRepairGroups({ commit, dispatch, rootGetters }) {
    return new Promise(resolve => {
      commit("setAllGroups", []);
      commit("setGroupsLoading", true);
      const token = rootGetters["login/phocusEnigmaApiToken"];
      const data = {
        accountId: rootGetters["login/selectedAccount"].id,
        technicianId: rootGetters["login/technicianId"],
        allGroups: true
      };

      let options = {
        headers: MakeAuthHeader(token),
        url: `${PhocusEnigmaApi}DeploymentGroup/assignedIds`,
        method: "POST",
        data: data
      };
      axios(options)
        .then(resp => {
          commit("setRepairGroups", resp.data);
          dispatch("GetRepairPois")
          .then(res => {
            commit("setGroupsLoading", false);
            resolve(res);
          })
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
          commit("setGroupsLoading", false);
        });
    });
  },
  GetRepairPois({ getters, commit, rootGetters }) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}poiCollection/GetRepairPois`;
      const data = {
        accountId: rootGetters["login/selectedAccount"].id,
        technicianId: rootGetters["login/technicianId"],
        groups: getters.repairGroups.map(l => l.id)
      };

      let options = {
        headers: MakeAuthHeader(token),
        url: url,
        method: "POST",
        data: data
      };
      axios(options)
        .then(resp => {
          commit("setRepairGroupPois", resp.data);
          resolve(true);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
    
  },
  saveRepair({ commit, rootGetters }, data) {
    return new Promise(resolve => {
      const token = rootGetters["login/poiApiToken"];
      const url = `${PrimePoiApiRoot}technician/UpdateRepair`;
      
      let options = {
        headers: MakeAuthHeader(token),
        url: url,
        method: "PUT",
        data: data
      };
      axios(options)
        .then(resp => {
          commit("removeRepairPoi", data);
          resolve(true);
        })
        .catch(error => {
          console.warn(error);
          resolve(false);
        });
    });
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
